"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.padding=exports.lineHeight=exports.fontWeight=exports.fontSize=exports.color=exports.Typography=void 0;/**
 * @description
 ** Defining Typographies based on variant
 * @param variant
 ** required
 * h6 {
 ** Weight: 500
 ** Size: 20px
 ** Line height: 26px
 *}

 * body1 {
 ** Weight: 600
 ** Size: 16px
 ** Line height: 22px
 *}

 * body2 {
 ** Weight: 400
 ** Size: 16px
 ** Line height: 20px
 *}
 * caption1 {
 * Weight: 400
 * Size: 12px
 * Line height: 16px
 * color: '#7c7575
 * } 
 * 
 * * caption2 {
 * Weight: 400
 * Size: 12px
 * Line height: 16px
 * } 
 * 
 *  * * price {
 * Weight: 700
 * Size: 16px
 * Line height: 24px
 * } 
 */const fontWeight=a=>{switch(a){case"caption1":case"caption2":case"caption3":case"body2":return 400;case"price":return 700;case"h6":return 500;case"body1":default:return 600}};exports.fontWeight=fontWeight;const fontSize=a=>{switch(a){case"caption1":case"caption2":return"12px";case"caption3":return"14px";case"h6":return"20px";case"body1":case"body2":default:return"16px"}};exports.fontSize=fontSize;const lineHeight=a=>{switch(a){case"caption1":case"caption2":return"16px";case"h6":return"26px";case"body2":return"20px";case"price":return"24px";case"body1":default:return"22px"}};exports.lineHeight=lineHeight;const color=a=>{switch(a){case"caption1":return"#7c7575";case"caption2":return"#111820";case"price":return"#121017";case"body1":default:return"#2b0810"}};exports.color=color;const padding=a=>"body1"===a?"2px 0px":"0px";exports.padding=padding;const Typography=exports.Typography=_styledComponents.default.div`
  font-style: normal;
  font-weight: ${a=>fontWeight(a.variant)};
  font-size: ${a=>fontSize(a.variant)};
  line-height: ${a=>lineHeight(a.variant)};
  color: ${a=>color(a.variant)};
  padding: ${a=>padding(a.variant)};
`;